export default __webpack_public_path__ + "static/media/enrichmydata-logo.3ee5a326.svg";